import { LoadingClaro } from 'common-ui-components';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { navigateTo } from '../../redux/Slice/navigationSlice';
import { useEffect } from 'react';
import { validateIdu } from '../../redux/Slice/referralSlice';

const ValidateIdu = () => {
  const [searchParams] = useSearchParams();
  const idu = searchParams.get('idu') || '';
  const dispatch = useDispatch();

  const validate = async () => {
    try {
      const response = await dispatch(validateIdu(idu)).unwrap();
      if (response?.status !== '200') {
        throw new Error('Error');
      }
      dispatch(navigateTo('DocumentTypeSelection'));
    } catch (error) {
      switch (error?.errorCode) {
        case '100010':
          dispatch(navigateTo('FinishedReferralError'));
          break;
        case '100011':
          dispatch(navigateTo('InvitationAlreadyUsedError'));
          break;
        case '100012':
          dispatch(navigateTo('InvitationExpired'));
          break;
        case '100013':
          dispatch(navigateTo('InvitationCancelledError'));
          break;
        case '100014':
          dispatch(navigateTo('InvalidLinkError'));
          break;
        default:
          dispatch(navigateTo('InvalidLinkError'));
      }
    }
  };

  useEffect(() => {
    validate();
  }, []);

  return (
    <LoadingClaro
      text={'Validando datos... Esperá por favor.'}
      fullViewportSize={true}
      overlay={true}
    />
  );
};

export default ValidateIdu;
